<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <section-donnees-entree :resultat="resultat"
                                        :col-left="colLeft"
                                        :col-right="colRight"
                                        table-class="table table-bordered table-striped">
                </section-donnees-entree>
            </div>
        </div>
        <div v-if="(resultat.isBaremeRectif || resultat.isBaremeAjuste)">
            <div class="row">
                <div class="col-md-12">
                    <section-resultat-prelevement :resultat="resultat"
                                                  :col-left="colLeft"
                                                  :col-right="colRight"
                                                  table-class="table table-bordered table-striped">
                    </section-resultat-prelevement>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <section-resultat-calculette :resultat="resultat"
                                             :col-left="colLeft"
                                             :col-right="colRight"
                                             table-class="table table-bordered table-striped">
                </section-resultat-calculette>
            </div>
        </div>
        <div v-if="(resultat.isBaremeRectif || resultat.isBaremeAjuste)">
            <div class="row">
                <div class="col-md-12">
                    <section-bilan :resultat="resultat"
                                   :col-left="colLeft"
                                   :col-right="colRight"
                                   table-class="table table-bordered table-striped">
                    </section-bilan>
                </div>
            </div>
        </div>
        <section-info></section-info>
    </div>
</template>

<script>

import SectionDonneesEntree from './SectionDonneesEntree.vue';
import SectionResultatPrelevement from './SectionResultatPrelevement.vue';
import SectionResultatCalculette from './SectionResultatCalculette.vue';
import SectionBilan from './SectionBilan.vue';
import SectionInfo from './SectionInfo.vue';

export default {
  name: 'calculette-resultat',
  data() {
    return {
      colLeft: (this.resultat.revenuContribuableEUR || this.resultat.revenuConjointEUR) ? 'col-md-9' : 'col-md-10',
      colRight: (this.resultat.revenuContribuableEUR || this.resultat.revenuConjointEUR) ? 'col-md-3 text-right' : 'col-md-2 text-right',
    };
  },
  props: ['resultat', 'titre'],
  components: {
    SectionDonneesEntree,
    SectionResultatPrelevement,
    SectionResultatCalculette,
    SectionBilan,
    SectionInfo,
  },
};
</script>

<style scoped>
    /deep/ table  tr:first-child > td {
        border-top: none;
    }

</style>
